import {MenuItem as SharedMenuItem, Colors} from "@bounce/shared/ui";
import type {MenuItemProps} from "@mui/material";

export const MenuItem = ({sx, ...props}: MenuItemProps) => (
  <SharedMenuItem
    sx={{
      "&:hover": {
        backgroundColor: Colors.blue._100,
      },
      ...sx,
    }}
    {...props}
  />
);
